import axios from 'axios'

export default class EntityProductService {
  static create = (entityId, data) => axios.post(`/entities/${entityId}/products`, data)
  static update = (id, data) => axios.put(`/entity-products/${id}`, data)
  static delete = id => axios.delete(`/entity-products/${id}`)
  static list = (entityId, { parameters, filters }) =>
    axios.get(`/entities/${entityId}/products${ filters }`, { params: parameters, excludeLoader: true })

  static history = (entityId, productId, { parameters, filters }) =>
    axios.get(`/entities/${entityId}/products/${productId}/history${ filters }`, { params: parameters, excludeLoader: true })

  static unlink = (entityId, productId) =>
    axios.post(`/entities/${entityId}/products/${productId}/unlink`)
}
